import React from 'react';
import performaDownload from '../../assets/logos/performaDownload.svg';
import { t } from 'i18next';
import { devUrl, endpoints, POST } from '../../services/modulesServices/userManagement.api';
import { cross } from '../../utils/Logo';

function InvoicePerformaDownload({ payload, setIsLoading, setModalDetails }: any) {
    const downloadPerforma = async () => {
        try {
            setIsLoading(true);

            const { data } = await POST(endpoints.performaInvoiceGenerate, payload);
            if (data?.proformaInvoiceDocReferenceId) {
                const downloadFileUrl = `${devUrl}/filestore/v1/files/download?tenantId=ga&fileStoreIds=${data?.proformaInvoiceDocReferenceId}`;
                window.open(downloadFileUrl);
            } else {
                setModalDetails({ show: true, title: 'Error!', para: 'File not found', img: cross, type: 'error', reUpload: 'OK' });
            }

            setIsLoading(false);
        } catch (e: any) {
            setIsLoading(false);
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };
    return (
        <div className='font-inter font-14 d-flex align-items-center justify-content-between proforma-invoice-dowmload px-4 py-2 mb-3'>
            <div>{t('GET_INVOICE_FOR_THE_PAYMENT', 'Get invoice for the payment you are about to complete')}</div>
            <div className='d-flex align-items-center justify-content-center' style={{ cursor: 'pointer' }} onClick={downloadPerforma}>
                <span>
                    <img src={performaDownload} alt='' width='100%' height='100%' />
                </span>
                <span className='download-button ps-1'>{t('DOWNLOAD_INVOICE', 'Download Invoice')}</span>
            </div>
        </div>
    );
}

export default InvoicePerformaDownload;
